import * as core from '../../../../../../../core'

import { query } from './employee-asset-leaderboard.query'

export const RESOURCE = {
  payload: {
    alias: 'employee.asset.leaderboard',
    description: 'Shows leaderboard of Employees adopting AI-Enabled Assets',
    name: 'Employee Asset Leaderboard',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
